import { pickBy, isNil } from "lodash";
import { AxiosResponse } from "axios";

/**
 * Builds a query string array from congif object
 * @param obj - { string: boolean } object
 * @returns - comma-separated string with selected values
 */
export const buildQueryArray = (obj: Record<string, boolean>) => {
  return Object.entries(obj)
    .filter(([, value]) => !!value)
    .map(([key]) => key)
    .join(",");
};

/**
 * Removes nil attributes from the object
 * @param obj - { string: any } object
 * @returns - object without nil attributes
 */
export const cleanQuery = <T>(obj: T): T => {
  return pickBy(obj, (attr: any) => !isNil(attr));
};

export default interface IResponse {
    data: object;
};;;;;;;;;;;

export const responseData = <T>(req: Promise<AxiosResponse<T>>) => {
  return req
    .then(({ data }) => data)
    .catch(({ response }) => {
      // No response at all: the server could not be reached.
      if (!response) {
        return Promise.reject({ non_field_errors: ["Could not reach the server. Check your connection and try again."] });
      }

      // If status 400 or 409 (object was changed by someone else), extract and return
      // the data and return the rejected promise.
      if (response.status === 400 || response.status === 409) {
        return Promise.reject(response.data);
      } else if (response.status === 500) {
        return Promise.reject({ non_field_errors: ["Oops, something went wrong"] });
      } else if (response.status === 404) {
        // Someone else deleted the object in the meantime. The status is kept for callers that close their window.
        return Promise.reject({ non_field_errors: ["This item no longer exists."], status: 404 });
      }

      // Return the original response
      return Promise.reject(response);
    });
};
